import React, { useEffect, useState } from "react";
import cl from "./Stories.module.css";
import api from "../../../api";
import axios from "axios";
import { accessGlobalUserState } from "../../../stores/user";
import EditStory from "./EditStory";
import { useNavigate } from "react-router-dom";

export const StoryThumbnail = ({
  image,
  onclick,
  edit = false,
  onFileChange,
  localImage = null,
}) => {
  const fileInputRef = React.useRef(null);
  const handleClick = () => {
    if (image) {
      return;
    }
    fileInputRef.current.click();
  };
  return (
    <div
      className={cl.storyThumbnail}
      onClick={() => {
        if (edit) {
          handleClick();
          return;
        }
        onclick();
      }}
    >
      {image ? (
        <img
          src={localImage ? image : `${api.serverUrl}/stories/${image}`}
          alt='story img'
          className={cl.storyImage}
        />
      ) : (
        <div>+</div>
      )}
      <input
        type='file'
        multiple={true}
        accept='image/*'
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={onFileChange}
      />
    </div>
  );
};

export const Stories = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [stories, setStories] = useState([]);
  const userState = accessGlobalUserState().get();
  const [selectedStory, setSelectedStory] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigation = useNavigate();

  const fetchStories = async () => {
    const res = await axios.get(`${api.serverUrl}/api/v1/stories/all`, {
      headers: {
        Authorization: `Bearer ${userState.token}`,
      },
    });

    if (res.status == 200) {
      setStories(res.data.stories);
      console.log("stories: ", res.data.stories);
    }
  };

  const handleClick = (storyID) => {
    const story = stories.find((story) => story._id === storyID);
    setSelectedStory(story);
    setCurrentPage(1);
    // redirect to edit story page
    navigation("/upload/stories/edit", {
      state: {
        story: story,
      },
    });
  };

  useEffect(() => {
    fetchStories();
  }, []);

  return (
    <div className={cl.wrapper}>
      <div className={cl.stories}>
        <StoryThumbnail onclick={() => handleClick()} />
        {stories.map((story) => (
          <StoryThumbnail
            key={story._id}
            image={`${story.slides[0].url}`}
            onclick={() => handleClick(story._id)}
          />
        ))}
      </div>
    </div>
  );
};
